<template>
  <main>
    <wl-banner bgUrl='/static/img/product/whpManageSystem/banner.png' :bannerData='bannerData'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1 bg" v-lazy:background-image="'/static/img/product/whpManageSystem/page1.png'">
      <article class="container flex">
        <section class="img"></section>
        <wl-title :title='page1Data.title' :desc='page1Data.desc' class="mytitle"></wl-title>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/product/whpManageSystem/page2.png'">
      <article class="container flex">
        <section class="box" v-for="(item,index) in page2Data" :key="index">
          <h3>{{item.title}}</h3>
          <p>{{item.desc}}</p>
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/whpManageSystem/page3.png'">
      <article class="container">
        <wl-title title='危化品全生命周期管理' :isNeedDesc=false></wl-title>
      </article>
    </section>
    <section class="page4 bg" v-lazy:background-image="'/static/img/product/whpManageSystem/page4.png'">
    </section>
    <section class="page5 bg" v-lazy:background-image="'/static/img/product/whpManageSystem/page5.png'">
      <article class="container">
        <wl-title title='应用价值帮您实现' :isNeedDesc=false></wl-title>
        <section class="box" v-for="(item,index) in page5Data" :key="index">
          <h3>{{item.title}}</h3>
          <p>{{item.desc}}</p>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'whpManageSystem',
  data() {
    return {
      bannerData: {
        title: '实验室危化品管理系统',
        desc: '危化品全生命周期管理\n库存可查、来源可循、去向可追、状态可控'
      },
      page1Data: {
        title: '实验室危化品管理系统',
        desc: '危化品管理系统依照“全流程闭环管控、线上线下结合、智能硬件辅助”的原则，采用全生命周期管理模式，实现危化品和其他试剂耗材的申购、采购、验收、入库、领用、出库、使用、消耗、报废、处置、监控等环节全流程管理，从源头上限量管理、实施流向追踪、力求“全程可控”，及时采取有效措施，大大降低事故发生概率。'
      },
      page2Data: [
        { title: '采购环节', desc: '采购过程繁琐没有科学预估易多量重复采购' },
        { title: '储存环节', desc: '化学品不分类存储，随意堆放，库存不准确' },
        { title: '使用环节', desc: '领用无审核发放随意，无法实现追溯责任到人' },
        { title: '危废处置', desc: '废弃物乱丢弃无集中处置和跟踪记录' },
      ],
      page5Data: [
        { title: '全流程生命周期管理，库存台账精确化', desc: '全流程管控，一物一码精准到货位、批号，库存明细实时可查' },
        { title: '保障落实危化品“五双”设定，领用存储规范化', desc: '自动化的方式落实实验室五双标准，领用存储' },
        { title: '灵活搭载智能硬件，过程管理智能化', desc: '与智能试剂柜、智能锁、天平、门禁视频等联动，实时监控和追溯' },
      ],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
main {
  background: #fbfbff;
  text-align: left;
}
h3 {
  font-size: 24px;
  font-weight: 500;
  color: #262626;
  line-height: 24px;
  padding-bottom: 20px;
  padding-top: 6px;
}
p {
  font-size: 14px;
  color: #8e8e8e;
  line-height: 22px;
}
.page1 {
  height: 495px;
  padding-top: 95px;
  .img {
    width: 526px;
    opacity: 0;
  }
  .mytitle {
    width: 565px;
    margin-left: 169px;
    ::v-deep strong {
      color: #8e8e8e;
      line-height: 38px;
      padding-top: 23px;
    }
    ::v-deep h2 {
      padding-top: 19px;
    }
  }
}
.page2 {
  height: 584px;
  padding-top: 374px;
  .container {
    width: 1260px;
  }
  .box {
    width: 242px;
    &:nth-child(1) {
      margin-right: 91px;
      margin-left: 24px;
    }
    &:nth-child(2) {
      margin-right: 92px;
    }
    &:nth-child(3) {
      margin-right: 95px;
    }
    h3 {
      padding-bottom: 19px;
      padding-top: 0;
    }
    p {
      font-size: 20px;
      color: #8E8E8E;
      line-height: 28px;
    }
  }
}
.page3 {
  height: 1394px;
  padding-top: 84px;
  text-align: center;
}
.page4 {
  height: 627px;
}
.page5 {
  height: 677px;
  padding-top: 152px;
  h3 {
    padding: 0;
    padding-bottom: 16px;
  }
  p {
    font-size: 20px;
    line-height: 20px;
  }
  .container {
    .box {
      padding-left: 52px;
      padding-bottom: 50px;
      &:nth-child(2) {
        padding-top: 72px;
      }
    }
  }
}
</style>
